/**
 * Base modules
 */
export * from './ajax';
export * from './animation';
export * from './base';
export * from './browser';
export * from './component';
export * from './child-property';
export * from './draggable';
export * from './droppable';
export * from './event-handler';
export * from './internationalization';
export * from './keyboard';
export * from './l10n';
export * from './module-loader';
export * from './notify-property-change';
export * from './touch';
export * from './hijri-parser';
export * from './template-engine';
export * from './util';
export * from './dom';
export * from './observer';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-base/src/index.js
// module id = 1812
// module chunks = 0